import { formatNumberWithSpaces } from 'utils/numbers'

// Libellés partagés par la liste et le formulaire de création
export const CAMPAIGN_TYPES = {
  structured_product: 'Cashback sur produit structuré',
  margin_trades_completed: 'Gagne X € après X trades levier',
  margin_gains_doubled: 'Double tes gains levier',
  reduced_fees_category: 'Frais réduits sur une catégorie de produit',
  refund_margin_loss: 'Remboursement des pertes (leverage)',
  overnight_fees_discount: 'Frais overnight réduits (leverage)',
  bonus: 'Bonus levier forex / métaux (freebet)',
}

// Libellés courts pour la colonne Type de la liste (margin_fees_discount : anciennes campagnes uniquement)
export const CAMPAIGN_TYPES_SHORT = {
  structured_product: 'Cashback PS',
  margin_trades_completed: 'Trades levier',
  margin_gains_doubled: 'Gains doublés',
  margin_fees_discount: 'Frais levier réduits',
  reduced_fees_category: 'Frais réduits',
  refund_margin_loss: 'Pertes remboursées',
  overnight_fees_discount: 'Frais overnight',
  bonus: 'Bonus',
}

export const CAMPAIGN_PAGES = {
  feed: 'Feed',
  trade: 'Trade',
  leverage: 'Leverage',
}

export const FEES_CATEGORIES = {
  stocks: 'Stocks',
  metals: 'Or / Argent',
  forex: 'Forex',
}

// Une campagne sans date de fin court jusqu'à ce qu'on la termine
export const campaignStatus = ({ start_date, end_date }, now = new Date()) => {
  if (end_date && new Date(end_date) <= now) return 'ended'
  if (new Date(start_date) > now) return 'upcoming'
  return 'running'
}

export const CAMPAIGN_STATUS = {
  upcoming: 'À venir',
  running: 'En cours',
  ended: 'Terminée',
}

// Résumé lisible des paramètres d'une campagne, affiché sous son type dans la liste
export const campaignSummary = ({ type, details = {}, maximum_gains }) => {
  const cap = maximum_gains > 0 ? ` · max ${formatNumberWithSpaces(maximum_gains)} €` : ''
  switch (type) {
    case 'structured_product':
      return `${details.percentage} % de cashback dès ${formatNumberWithSpaces(details.minimum_investment || 0)} €${cap}`
    case 'margin_trades_completed':
      return `${formatNumberWithSpaces(details.gains)} € après ${details.minimum_trades} trades`
    case 'reduced_fees_category':
      return `-${details.percentage} % de frais · ${FEES_CATEGORIES[details.category] || details.category}${cap}`
    case 'overnight_fees_discount':
      return `-${details.percentage} % de frais overnight`
    case 'bonus':
      return `${formatNumberWithSpaces(details.amount)} € de bonus par client, donnés à la création`
    default:
      return cap ? cap.slice(3) : ''
  }
}
